import { formatDate } from "../../../utils/date";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Performance.module.css";

const isRowFilled = (row) =>
  Object.values(row ?? {}).some((v) => String(v ?? "").trim());

// Editable rows (e.g. Development Plan). `onChange` absent = read-only.
const TableSection = ({ section, answer = {}, onChange }) => {
  const columns = section.columns ?? [];
  const rows = answer.rows ?? [];
  const readOnly = !onChange;
  const shownRows = readOnly
    ? rows.filter(isRowFilled)
    : rows.length
      ? rows
      : [{}];
  const canAddRow = !section.maxRows || shownRows.length < section.maxRows;

  if (readOnly && !shownRows.length)
    return <p className={cx(ui.muted, "mb-0")}>Nothing entered.</p>;

  const update = (next) => onChange({ ...answer, rows: next });
  const updateCell = (rowIndex, key, value) =>
    update(
      shownRows.map((row, i) =>
        i === rowIndex ? { ...row, [key]: value } : row,
      ),
    );

  return (
    <div className={ui.tableWrapper}>
      <table className={ui.table}>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key}>{c.label}</th>
            ))}
            {!readOnly && <th></th>}
          </tr>
        </thead>
        <tbody>
          {shownRows.map((row, i) => (
            <tr key={i}>
              {columns.map((c) => (
                <td key={c.key}>
                  {readOnly ? (
                    (c.type === "date" && row[c.key]
                      ? formatDate(row[c.key])
                      : row[c.key]) || "—"
                  ) : (
                    <input
                      type={c.type === "date" ? "date" : "text"}
                      className={cx(ui.input, styles.tableInput)}
                      maxLength={2000}
                      value={row[c.key] ?? ""}
                      onChange={(e) => updateCell(i, c.key, e.target.value)}
                      aria-label={`${c.label}, row ${i + 1}`}
                    />
                  )}
                </td>
              ))}
              {!readOnly && (
                <td className="text-end">
                  <button
                    type="button"
                    className={ui.iconButton}
                    onClick={() => update(shownRows.filter((_, j) => j !== i))}
                    aria-label={`Remove row ${i + 1}`}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {!readOnly && canAddRow && (
        <button
          type="button"
          className={cx(ui.linkButton, "mt-2")}
          onClick={() => update([...shownRows, {}])}
        >
          <i className="bi bi-plus"></i> Add row
        </button>
      )}
    </div>
  );
};

export default TableSection;
